import React, {useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router';
import PulsoidClient from '../../../../PulsoidClient';
import {LoaderWrapper} from '../../../../system/Loader/Loader';
import {YearlyReportV2} from '../YearlyReportV2';
import {YearlyReport} from '../../YearlyReport';
import css from './YearlyReportV2Container.module.css';

export const YearlyReportV2Container = () => {
  const params = useParams();
  let [report, setReport] = useState();
  const originalTitle = useRef(document?.title).current;

  const isScreenshot = document.location.search.includes('screenshot=true');

  const fetchReport = async () => {
    const reportData = await new PulsoidClient({
      publicRpc: true,
    }).getYearlyReportById(params.id);
    setReport(reportData);
  };

  useEffect(() => {
    fetchReport();
  }, []);

  useEffect(() => {
    const viewportMeta = document.querySelector('meta[name=viewport]');
    const oldViewportContent = viewportMeta?.content;

    if (viewportMeta) {
      viewportMeta.content = 'width=device-width, initial-scale=0.75';
    }

    return () => {
      if (viewportMeta) {
        viewportMeta.content = oldViewportContent;
      }
    };
  }, []);

  useEffect(() => {
    let newTitle = `${report?.year || '2022'}OfMyHeart | Pulsoid Yearly Report`;

    if (report?.nickname) {
      newTitle = `${report?.nickname}’s ${newTitle}`;
    }

    document.title = newTitle;

    return () => {
      document.title = originalTitle;
    };
  }, [report]);

  return (
    <div className={css.root}>
      <LoaderWrapper loading={!report} color="#ffffff">
        {report?.year === 2021 ? (
          <div style={{width: '100%', backgroundColor: '#222222'}}>
            <YearlyReport report={report} />
          </div>
        ) : (
          <YearlyReportV2
            report={report}
            nickname={report?.channel}
            isPublicVersion={true}
            isScreenshot={isScreenshot}
          />
        )}
      </LoaderWrapper>
    </div>
  );
};
